export default `uniform vec3 diffuse;uniform float opacity;uniform float linewidth;uniform vec3 uStartPoint;uniform vec3 uEndPoint;uniform float uAngle;uniform vec2 resolution;uniform mat4 projectionMatrix;uniform mat4 modelViewMatrix;varying vec3 vInstanceStart;varying vec3 vInstanceEnd;
#ifdef USE_DASH
uniform float dashOffset;uniform float dashSize;uniform float gapSize;
#endif
uniform float uDistance;uniform float uTime;varying float vLineDistance;
#ifdef WORLD_UNITS
varying vec4 worldPos;varying vec3 worldStart;varying vec3 worldEnd;
#ifdef USE_DASH
varying vec2 vUv;
#endif
#else
varying vec2 vUv;
#endif
#include <common>
#include <fog_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
#ifdef USE_COLOR
#ifdef USE_LINE_COLOR_ALPHA
varying vec4 vLineColor;
#else
varying vec3 vLineColor;
#endif
#endif
#define LINE_TWO_PI 6.28318530718
#define LINE_HALF_PI 1.57079632679
#define LINE_ONE_POINT_FIVE_PI 4.71238898038
#define LINE_COLOR_DARK vec3(0.0, 0.286274509, 0.658823529)
#define LINE_COLOR_LIGHT vec3(0.0, 0.431372549, 1.0)
vec2 closestLineToLine(vec3 p1,vec3 p2,vec3 p3,vec3 p4){float mua;float mub;vec3 p13=p1-p3;vec3 p43=p4-p3;vec3 p21=p2-p1;float d1343=dot(p13,p43);float d4321=dot(p43,p21);float d1321=dot(p13,p21);float d4343=dot(p43,p43);float d2121=dot(p21,p21);float denom=d2121*d4343-d4321*d4321;float numer=d1343*d4321-d1321*d4343;mua=numer/denom;mua=clamp(mua,0.0,1.0);mub=(d1343+d4321*(mua))/d4343;mub=clamp(mub,0.0,1.0);return vec2(mua,mub);}void main(){
#include <clipping_planes_fragment>
#ifdef USE_DASH
if(vUv.y<-1.0||vUv.y>1.0)discard;if(mod(vLineDistance+dashOffset,dashSize+gapSize)>dashSize)discard;
#endif
float alpha=opacity;
#ifdef WORLD_UNITS
vec3 rayEnd=normalize(worldPos.xyz)*1e5;vec3 lineDir=worldEnd-worldStart;vec2 params=closestLineToLine(worldStart,worldEnd,vec3(0.0,0.0,0.0),rayEnd);vec3 p1=worldStart+lineDir*params.x;vec3 p2=rayEnd*params.y;vec3 delta=p1-p2;float len=length(delta);float norm=len/linewidth;
#ifndef USE_DASH
#ifdef USE_ALPHA_TO_COVERAGE
float dnorm=fwidth(norm);alpha=1.0-smoothstep(0.5 - dnorm,0.5+dnorm,norm);
#else
if(norm>0.5){discard;}
#endif
#endif
#else
#ifdef USE_ALPHA_TO_COVERAGE
float a=vUv.x;float b=(vUv.y>0.0)? vUv.y-1.0 : vUv.y+1.0;float len2=a*a+b*b;float dlen=fwidth(len2);if(abs(vUv.y)>1.0){alpha=1.0-smoothstep(1.0 - dlen,1.0+dlen,len2);}
#else
float absUvY=abs(vUv.y);if(absUvY>1.0){float a=vUv.x;float b=(vUv.y>0.0)? vUv.y-1.0 : vUv.y+1.0;float len2=a*a+b*b;if(len2>1.0){discard;}float ang=atan(a,b);if(ang<0.0){ang+=LINE_TWO_PI;}float angle=PI-uAngle;if(ang<=LINE_ONE_POINT_FIVE_PI-angle||ang>LINE_ONE_POINT_FIVE_PI){discard;}}else{mat4 projModelView=projectionMatrix*modelViewMatrix;vec4 clipStartPoint=projModelView*vec4(vInstanceStart,1.0);vec4 clipEndPoint=projModelView*vec4(vInstanceEnd,1.0);vec3 ndcStartPoint=clipStartPoint.xyz/clipStartPoint.w;vec3 ndcEndPoint=clipEndPoint.xyz/clipEndPoint.w;vec2 screenStartPoint=(ndcStartPoint.xy+1.0)*0.5*resolution;vec2 screenEndPoint=(ndcEndPoint.xy+1.0)*0.5*resolution;float dist=length(screenEndPoint-screenStartPoint);float uvYDist=linewidth/dist;if(absUvY>1.0-uvYDist){float a=vUv.x;float b=(vUv.y>0.0)? 1.0-vUv.y : vUv.y+1.0;b/=uvYDist;float len2=a*a+b*b;float ang=atan(a,b);if(ang<0.0){ang+=LINE_TWO_PI;}float angleSupplement=uAngle-LINE_HALF_PI;float angle=uAngle-2.0*angleSupplement;if(len2<1.0&&ang>LINE_HALF_PI-angle*0.5&&ang<LINE_HALF_PI){discard;}}}
#endif
#endif
vec3 instanceDiff=vInstanceEnd-vInstanceStart;float dist=length(instanceDiff);vec4 diffuseColor=vec4(diffuse,alpha);float ratio=clamp((vUv.y+1.0)*0.5,0.0,1.0);if(uDistance>0.0){float invDistance=1.0/uDistance;float distRatio=dist*invDistance;if(all(equal(vInstanceStart,uStartPoint))){ratio*=distRatio;}else if(all(equal(vInstanceEnd,uEndPoint))){ratio=1.0-distRatio+ratio*distRatio;}else{float distToStart=length(vInstanceStart-uStartPoint);ratio=distToStart*invDistance+ratio*distRatio;}}float animValue=ratio*uDistance*2.0-400.0 - uTime;float t=fract(animValue);int index=int(floor(animValue));float selector=mod(float(index),2.0);vec3 color=mix(LINE_COLOR_DARK,LINE_COLOR_LIGHT,selector+t*(1.0-2.0*selector));
#ifdef USE_COLOR
#ifdef USE_LINE_COLOR_ALPHA
diffuseColor*=vec4(color,1.0);
#else
diffuseColor.rgb*=color;
#endif
#endif
#include <logdepthbuf_fragment>
gl_FragColor=vec4(diffuseColor.rgb*color,diffuseColor.a);
#include <tonemapping_fragment>
#include <colorspace_fragment>
#include <fog_fragment>
#include <premultiplied_alpha_fragment>
}`